/**
 * 商品卡自定义色卡：点击切换卡片图片（不跳转）。
 *
 * 幻灯片带 slide-id="<media_id>"（snippets/card-gallery.liquid 的 slide_id: media.id），
 * 优先调用 slideshow-component.select({ id })。
 *
 * 但实测有商品「点击完全没反应、也不跳转」—— 说明 select() 被调用却静默失败
 * （assets/slideshow.js 的 select() 开头有多处静默 return：
 *  `!#disabled`、`!this.#scroll`、requestedIndex 解析失败、已是当前页 等）。
 * 因此这里加了兜底：调用 select 后若目标幻灯片仍未显形，就自己操作 DOM 切换。
 *
 * 另外两个坑：
 *  1) 主题 resetImage→#resetVariant 找不到「已选变体」时会回到 initialSlide，
 *     导致选完色卡鼠标一移开就变回第一张 → 选中后在捕获阶段拦住悬停事件。
 *  2) 若目标幻灯片不存在，select() 会静默 return；此时不能吞掉点击，
 *     要放行让链接正常跳转。
 */
(function () {
  var FALLBACK_DELAY = 350;

  function getSlideshow(card) {
    var ss = card.querySelector('slideshow-component');
    return ss && typeof ss.select === 'function' ? ss : null;
  }

  /**
   * 兜底切换：不依赖组件内部状态，直接显形 + 滚动到位。
   * 属性语义与主题 assets/slideshow.js 保持一致：
   * 隐藏幻灯片靠 [reveal] 解除 display:none，并用 aria-hidden 标记当前页。
   */
  function fallbackSelect(card, slide) {
    var slides = card.querySelectorAll('slideshow-slide');
    for (var i = 0; i < slides.length; i++) {
      if (slides[i] === slide) {
        slides[i].setAttribute('reveal', '');
        slides[i].setAttribute('aria-hidden', 'false');
      } else {
        slides[i].removeAttribute('reveal');
        slides[i].setAttribute('aria-hidden', 'true');
      }
    }
    if (typeof slide.scrollIntoView === 'function') {
      // block: 'nearest' 避免页面纵向跳动
      slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
    }
  }

  function selectMedia(card, mediaId) {
    var slide = card.querySelector('slideshow-slide[slide-id="' + mediaId + '"]');
    if (!slide) return false;

    var slideshow = getSlideshow(card);
    if (!slideshow) {
      fallbackSelect(card, slide);
      return true;
    }

    slideshow.select({ id: mediaId }, undefined, { animate: true });

    window.setTimeout(function () {
      if (slide.getAttribute('aria-hidden') !== 'false' && !slide.hasAttribute('reveal')) {
        fallbackSelect(card, slide);
      }
    }, FALLBACK_DELAY);

    return true;
  }

  function handleClick(event) {
    var link = event.target.closest && event.target.closest('.custom-card-swatches__item');
    if (!link) return;

    var mediaId = link.getAttribute('data-media-id');
    if (!mediaId) return;

    var card = link.closest('product-card');
    if (!card) return;

    if (!selectMedia(card, mediaId)) return;   // 切不了就保留原生跳转

    event.preventDefault();

    card.dataset.customSwatchMedia = mediaId;

    var items = card.querySelectorAll('.custom-card-swatches__item');
    for (var i = 0; i < items.length; i++) {
      items[i].classList.toggle('is-active', items[i] === link);
    }
  }

  /** 选中过色卡后，捕获阶段拦住 pointerenter / pointerleave */
  function guard(event) {
    var card = event.currentTarget;
    if (card.dataset && card.dataset.customSwatchMedia) {
      event.stopPropagation();
    }
  }

  function bindCard(card) {
    if (card.dataset.customSwatchBound) return;
    card.dataset.customSwatchBound = '1';
    card.addEventListener('pointerenter', guard, true);
    card.addEventListener('pointerleave', guard, true);
  }

  function init() {
    var cards = document.querySelectorAll('product-card');
    for (var i = 0; i < cards.length; i++) bindCard(cards[i]);
  }

  /**
   * 鼠标点击箭头后主动 blur。
   * 否则按钮保持焦点 → 卡片的 :focus-within 一直成立 →
   * 鼠标移开后箭头与 QUICK ADD 条仍停留在该卡片上。
   * 用 event.detail > 0 区分「真实指针点击」与「键盘触发」，
   * 键盘操作不动，保留可访问性。
   */
  document.addEventListener(
    'click',
    function (event) {
      var btn = event.target.closest && event.target.closest('slideshow-arrows .slideshow-control');
      if (!btn) return;
      if (event.detail > 0) btn.blur();
    },
    true
  );

  document.addEventListener('click', handleClick, false);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();